"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SerialQueue = void 0;
/**
 * SerialQueue runs 1 promise at a time, very useful for reducing load and working around lock files
 */
class SerialQueue {
    name;
    debug;
    items = [];
    isProcessing = false;
    constructor(name, debug = false) {
        this.name = name;
        this.debug = debug;
    }
    async processQueue() {
        if (this.isProcessing)
            return;
        const item = this.items.shift();
        if (item) {
            if (this.debug) {
                console.log(`Running queue item ${this.name}#${item.key ?? "unknown"}`);
            }
            this.isProcessing = true;
            try {
                const result = await item.callback();
                for (const resolve of item.resolves) {
                    try {
                        resolve(result);
                    }
                    catch (err) {
                        // do nothing
                    }
                }
            }
            catch (err) {
                for (const reject of item.rejects) {
                    try {
                        reject(err);
                    }
                    catch (err) {
                        // do nothing
                    }
                }
            }
            this.isProcessing = false;
            if (this.debug) {
                console.log(`Processed queue item ${this.name}#${item.key ?? "unknown"}`);
            }
            // Process next item
            this.processQueue();
        }
    }
    /**
     * Add a new promise callback to the queue
     *
     * in case you provide a key it will be used to de-duplicate against existing items in the queue
     * if there is an existing item, the callback of that item will be used and this function will
     * return the result of that callback instead
     */
    add(callback, key) {
        if (this.debug) {
            console.log(`Adding item ${this.name}#${key ?? "unknown"} to the queue`);
        }
        return new Promise((resolve, reject) => {
            let shouldAdd = true;
            let item = {
                key,
                callback,
                resolves: [],
                rejects: [],
            };
            if (key) {
                const foundItem = this.items.find((i) => i.key === key);
                if (foundItem) {
                    item = foundItem;
                    shouldAdd = false;
                }
            }
            item.resolves.push(resolve);
            item.rejects.push(reject);
            if (shouldAdd) {
                this.items.push(item);
            }
            this.processQueue().catch(console.error);
        });
    }
}
exports.SerialQueue = SerialQueue;
//# sourceMappingURL=data:application/json;base64,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